import React from 'react'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import AccommodationRoomTile from 'components/OfferPage/Accommodation/AccommodationRoomTile'
import AccommodationRoomTileImage from 'components/OfferPage/Accommodation/AccommodationRoomTileImage'
import BedbankAboutRoomModalTab from './BedbankAboutRoomModalTab'
import ModalBase from 'components/Luxkit/Modal/ModalBase'

interface Props {
  packageView: App.BedbankOfferPackageView;
  showBookmark?: boolean;
}

function BedbankRoomDetailsModal(props: Props) {
  const { packageView, showBookmark } = props

  if (!packageView) return null

  return (<ModalBase>
    <ModalHeader title={packageView.package.name} />
    <ModalBody>
      <AccommodationRoomTile roomPackage={packageView.package}>
        <AccommodationRoomTileImage roomPackage={packageView.package} showBookmark={showBookmark} />
      </AccommodationRoomTile>
      <BedbankAboutRoomModalTab packageView={packageView} />
    </ModalBody>
  </ModalBase>)
}

export default BedbankRoomDetailsModal
